import React, { useState } from "react";
import { SlSocialLinkedin } from "react-icons/sl";

const Profilecomponent = (props) => {
    const [isHovered, setIsHovered] = useState(false);
    const openLink = (url, event) => {
      event.stopPropagation();
      window.open(url, "_blank");
    };
    return (
      <div className=" flex flex-col items-center justify-center 2xl:gap-6 xl:gap-4 gap-3  xl:px-4 xl:py-6 px-2 py-4  md:rounded-2xl   rounded-md   w-[13rem] h-[18rem]"
      >
        {/* <div className="profileclass "> */}
        <div className="flex items-center justify-center w-[7.5rem] h-[7.5rem] rounded-[4.5rem] p-2 videoBackground border-[0.06rem] border-[#444D61] ">
        <img
          className=" object-fill w-[6rem] h-[6rem]   rounded-full"
          src={props.img}
        ></img>
        </div>
        {/* </div> */}
        <div className="flex flex-col items-center justify-center md:gap-6 gap-1">
        
            <div className=" flex flex-col items-start justify-center md:gap-1 gap-[0.15rem]">
              <p className="w-full font-RobotoRegular md:text-[1rem] text-sm text-white text-center">
                {props.name}
              </p>
              <p
                className={`w-full font-RobotoRegular text-xs md:text-sm   text-white text-center`}
              >
                {props.title}
              </p>
            </div>
            <div
              onClick={(event) => openLink(props.linkedin, event)}
              className="2xl:w-[4rem] 2xl:h-[4rem]  rounded-full cursor-pointer w-[2.5rem] h-[2.5rem]  videoBackground flex items-center justify-center shadow-lg shadow-gray-400 "
            >
              <SlSocialLinkedin size={20} color="#1B99D4" className="hidden md:block" />
              <SlSocialLinkedin size={12} color="#1B99D4" className="block md:hidden" />
            </div>
          </div>
        </div>
    );
}



const Advisors = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  const openLink = (url, event) => {
    // Stop event propagation to prevent the div click event from triggering
    event.stopPropagation();
    window.open(url, "_blank");
  };

  return (
    <div
      onMouseOver={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="flex flex-col items-center justify-center 2xl:gap-6 md:gap-4 gap-1 2xl:px-6 2xl:py-8 md:px-4 md:py-6 bg-black border-[0.03rem]   border-[#444D61] md:rounded-2xl  2xl:w-[24rem] 2xl:h-[8rem] xl:w-[19rem] xl:h-[6rem] w-[15rem] h-[4rem] rounded-md"
    >
      <div className="flex flex-col items-center justify-center md:gap-6 gap-1">
        <div className="w-full flex items-center justify-between md:gap-0 gap-3">
          <div className="2xl:w-[17rem] xl:w-[14rem] w-[10rem]  flex flex-col items-start justify-center md:gap-1 gap-[0.15rem]">
            <p className="font-opensans font-extrabold 2xl:text-lg  text-[#E7EAEE] text-[12px] xl:text-[15px] text-left">
              {props.name}
            </p>
            <p
              className={`font-opensans font-bold 2xl:text-[0.675rem] xl:text-[0.6rem] md:text-[0.5rem] text-[0.3rem]  text-left ${
                isHovered ? "text-blue-50" : ""
              } text-[#E7EAEE]/50`}
            >
              {props.title}
            </p>
          </div>
          <div
            onClick={(event) => openLink(props.linkedin, event)}
            className="2xl:w-[3rem] 2xl:h-[3rem] 2xl:rounded-[0.75rem] md:w-[2.5rem] md:h-[2.5rem] md:rounded-[0.6rem] w-[2rem] h-[2rem] rounded-[0.75rem]  flex items-center justify-center hover:bg-[#0C2E52]/60"
          >
            <SlSocialLinkedin
              size={20}
              color="#1B99D4"
              className="hidden md:block"
            />
            <SlSocialLinkedin
              size={12}
              color="#1B99D4"
              className="block md:hidden"
            />
          </div>
        </div>
      </div>
    </div>
  );
}


export  {
  Profilecomponent,
  Advisors,
};
